import PropTypes from 'prop-types'
import { Component } from 'react'
import { Icon } from 'semantic-ui-react'

import { cn } from '@repo/utils'

import { SimpleButton } from 'ui'
import { ChildrenSchema, Timer } from 'utils'

import {
  NOTIFICATIONS_STATUS_ICONS as ICONS,
  NOTIFICATIONS_LABELS as LABELS,
  NOTIFICATIONS_STATUS as STATUS,
} from '../../constants'

import styles from './index.css'

class Notification extends Component {
  shouldComponentUpdate(nextProps) {
    const propForRender = ['buttons', 'children', 'className', 'icon', 'onClose', 'status', 'title']
    const propForTiming = ['buttons', 'children', 'dismissAfter', 'icon', 'onDismiss', 'status', 'title']
    const shouldResetTime =
      (!this.timer && nextProps.dismissAfter > 0) || propForTiming.some((p) => this.props[p] !== nextProps[p])

    if (shouldResetTime) {
      if (this.timer) {
        this.timer.stop()
      }

      if (nextProps.dismissAfter > 0) {
        this.timer = new Timer(nextProps.dismissAfter, nextProps.onDismiss)
        this.timer.start()
      }
    }

    return propForRender.some((p) => this.props[p] !== nextProps[p])
  }

  componentWillUnmount() {
    if (this.timer) {
      this.timer.stop()
    }
  }

  onClick = (event) => {
    const { onClick } = this.props
    const { classList } = event.target
    if (
      onClick &&
      (classList.contains(styles.wrapper) ||
        classList.contains(styles.icon) ||
        classList.contains(styles.body) ||
        classList.contains(styles.title) ||
        classList.contains(styles.content))
    ) {
      onClick(event)
    }
  }

  onKeyPress = (event) => {
    const { onClose } = this.props
    if (event.key === 'Enter' || event.key === 'Space') {
      this.onClick(event)
    } else if (onClose && event.key === 'Esc') {
      onClose(event)
    }
  }

  onMouseEnter = () => this.timer && this.timer.pause()

  onMouseLeave = () => this.timer && this.timer.resume()

  timer = null

  renderButtons = () => (
    <div aria-label="Con acciones." className={styles.buttonsList}>
      {this.props.buttons.map((button) => (
        <SimpleButton
          key={button.text}
          aria-roledescription="Notificación"
          ariaLabel={button.text}
          className={styles.button}
          icon={button.icon}
          onClick={button.onClick}
        >
          {button.text}
        </SimpleButton>
      ))}
    </div>
  )

  renderClose = () => (
    <div aria-label="Cancelable." className={styles.close}>
      <SimpleButton ariaLabel="Cerrar notificación" icon="cancel" onClick={this.props.onClose} />
    </div>
  )

  render() {
    const { buttons, children, className, icon, onClick, onClose, status, title } = this.props
    const statusStyleName = `status${(STATUS[status] || STATUS.DEFAULT)[0]}`
    const statusIcon = icon || ICONS[status]

    return (
      <div
        aria-live="polite"
        aria-roledescription="Notificación"
        className={cn(styles.wrapper, styles[statusStyleName], !!onClick && styles.clickable, className)}
        onClick={this.onClick}
        onKeyDown={this.onKeyPress}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        role="button"
        tabIndex={onClick ? 0 : -1}
      >
        {!!statusIcon && (
          <Icon aria-label={`Notificación de ${LABELS[status]}.`} className={styles.icon} name={statusIcon} />
        )}
        <div className={styles.body}>
          {!!title && <h2 className={styles.title}>{title}</h2>}
          <div className={styles.content}>{children}</div>
        </div>
        {!!onClose && this.renderClose()}
        {buttons.length > 0 && this.renderButtons()}
      </div>
    )
  }
}

Notification.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  children: ChildrenSchema,
  className: PropTypes.string,
  dismissAfter: PropTypes.number,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  onDismiss: PropTypes.func,
  status: PropTypes.oneOf(Object.keys(STATUS)),
  title: ChildrenSchema,
}

Notification.defaultProps = {
  buttons: [],
  children: null,
  className: '',
  dismissAfter: 0,
  icon: '',
  onClick: null,
  onClose: null,
  onDismiss: Function.prototype,
  status: null,
  title: '',
}

export default Notification
